


















import Vue, { PropType } from 'vue';
import store from '@/store';
import { WorkflowStep } from '@/store/getStarted';

import GetStartedNav from '@/components/getStarted/GetStartedNav.vue';
import GetStartedNavNextButton from '@/components/getStarted/GetStartedNavNextButton.vue';
import MultiPointPacketBuilder from '@/components/MultiPointPacketBuilder.vue';
import SinglePointPacketBuilder from '@/components/SinglePointPacketBuilder.vue';

export default Vue.extend({
  components: {
    GetStartedNav,
    GetStartedNavNextButton,
    MultiPointPacketBuilder,
    SinglePointPacketBuilder
  },

  props: {
    step: {
      type: Number as PropType<WorkflowStep>,
      required: true
    }
  },

  computed: {
    singlePoint(): boolean {
      return this.step === WorkflowStep.BUILD_SINGLE_POINT_GOALS;
    },

    multiPoint(): boolean {
      return !this.singlePoint;
    },

    missingInfo(): boolean {
      return !!this.messages.length;
    },

    messages(): string[] {
      return (this.singlePoint
        ? store.getters.singlePoint.messages
        : store.getters.multiPoint.messages
      ).map(message => '* ' + message);
    }
  },

  methods: {
    finish() {
      const { packet, badges } = this.singlePoint
        ? store.state.singlePoint
        : store.state.multiPoint;

      store.dispatch.getStarted.finishCreatePacket([packet, badges]);
      store.dispatch.getStarted.goToStep(WorkflowStep.REVIEW);
    },

    back() {
      store.dispatch.getStarted.goToStep(WorkflowStep.NEW_GOAL_KIND_BRANCH);
    }
  }
});
